<template>
  <TabbedBox>
    <template v-slot:tablist>
      <Tab :first="true" tabid="tab-1">
        <i class="far fa-users"></i> User Groups
      </Tab>
    </template>
    <template v-slot:tabcontent>
      <TabPage :first="true" tabid="tab-1">
        <DataTable :columns="columnList" :url="dataURL" :displayTools="true" :displayExportTools="true" exportTitle="User Groups">
          <template v-slot:title>
            <h3>User Group List</h3>
          </template>
          <template v-slot:tools>
            <LinkButton type="new" href="/users/groups/new" v-if="userHasCreatePermission(PermissionTypes.UserPermissionTypes.userGroup)" sizeClass="btn"> New User Group</LinkButton>
          </template>
          <template v-slot:row="row">
            <tr :key="row.data.id">
              <td class="table-data-nav-link">
                <i class="fas fa-users" :style="`color: ${row.data.colourTag};`"> </i> 
                <LinkUserGroup :name="row.data.name" :id="row.data.id" :newTab="false" />
              </td>
            </tr>
          </template>
        </DataTable>
      </TabPage>
    </template>
  </TabbedBox>
</template>

<script>
import TabbedBox from "@/components/layout/tabbedBox.vue"
import Tab from "@/components/layout/tab.vue"
import TabPage from "@/components/layout/tabPage.vue"

export default {
  name: "UserList",
  components: {
    TabbedBox,
    Tab,
    TabPage
  },
  computed: {
    dataURL() {
      var params = {
      }
      return '/usergroups?' + $.param(params)
    },
  },
  data: () => {
    return {
      breadcrumbs: [
        { title: 'User Groups', link: '/usergroups'}
      ],
      columnList: [
        { title: "Name", data: "name" }
      ]
    }
  }
};
</script>
